import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";

export const hasSurveyAwaitingResponse = (
  surveyId: string,
  options: APQueryOptions = {}
) => {
  const { fetchWithAuth } = useApi();
  const { isQueryEnabled } = useAPQuery();

  return useQuery({
    queryKey: ["survey-awaiting-response", surveyId],
    queryFn: (): Promise<boolean> => {
      return fetchWithAuth<boolean>("hasSurveyAwaitingResponse", surveyId);
    },
    enabled: isQueryEnabled(options),
  });
};
